import { useCallback } from 'react';

import { useStoreLocator } from 'pages/store-locator/hooks/use-store-locator';
import { useGeolocation } from 'state/geolocation';
import { useNearbyStoresContext } from 'state/nearby-stores';

interface IUseStoreNearbyReturn {
  selectFirstNearbyStore: VoidFunction;
}

export const useStoreNearby = (): IUseStoreNearbyReturn => {
  const { setStoresNearby: setStoresNearbyContext } = useNearbyStoresContext();
  const { storesNearby } = useStoreLocator();
  const { isPermissionDenied } = useGeolocation();

  const selectFirstNearbyStore = useCallback((): void => {
    if (isPermissionDenied || !storesNearby?.length) {
      setStoresNearbyContext({});
      return;
    }

    const { storeId, physicalAddress, customerFacingAddress } =
      storesNearby.find(nearbyStore => nearbyStore.isAvailable) || {};

    setStoresNearbyContext({
      storeId,
      address1: customerFacingAddress?.locale || physicalAddress?.address1 || null,
    });
  }, [isPermissionDenied, setStoresNearbyContext, storesNearby]);

  return {
    selectFirstNearbyStore,
  };
};
